export default __webpack_public_path__ + "static/lempire-1ee02d179ad78672e42be1c17ac87447.png";